"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePropsContext = exports.PropsContext = void 0;
var react_1 = __importStar(require("react"));
exports.PropsContext = (0, react_1.createContext)({});
var usePropsContext = function () { return (0, react_1.useContext)(exports.PropsContext); };
exports.usePropsContext = usePropsContext;
var PropsProvider = function (props) {
    var translate = props.translate, onSubmitForm = props.onSubmitForm, onClose = props.onClose, maxFilesSize = props.maxFilesSize, accept = props.accept, isLoading = props.isLoading;
    var value = (0, react_1.useMemo)(function () { return ({
        translate: translate,
        onSubmitForm: onSubmitForm,
        onClose: onClose,
        maxFilesSize: maxFilesSize,
        accept: accept,
        isLoading: isLoading
    }); }, [
        translate,
        onSubmitForm,
        onClose,
        maxFilesSize,
        accept,
        isLoading
    ]);
    return (react_1.default.createElement(exports.PropsContext.Provider, { value: value }, props.children));
};
exports.default = PropsProvider;
